import { SERVICE_AREAS, SERVICE_AREAS_BY_KEY } from "@/content/data";
import type { ServiceArea, ServiceAreaKey } from "@/content/types";

export function getServiceArea(key: ServiceAreaKey): ServiceArea {
  return SERVICE_AREAS_BY_KEY[key];
}

type GetServiceAreasOptions = {
  limit?: number;
};

export function getServiceAreas(
  keys?: ServiceAreaKey | ServiceAreaKey[],
  options?: GetServiceAreasOptions,
): ServiceArea[] {
  if (!keys) {
    return SERVICE_AREAS.slice(0, options?.limit);
  }

  const list = Array.isArray(keys) ? keys : [keys];

  return list
    .map(key => SERVICE_AREAS_BY_KEY[key])
    .filter(Boolean)
    .slice(0, options?.limit);
}
